import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M13.884 7.078a2.032 2.032 0 100-4.064 2.032 2.032 0 000 4.064zM20.935 19.362L18.978 13.1a4.052 4.052 0 00-.24-.67l-2.154-4.042a1.22 1.22 0 00-2.054-.173L12.21 11.3l-2.258 1.505a1.22 1.22 0 001.363 2.025l2.408-1.626c.112-.077.211-.17.294-.278l1.302-1.702.94 1.792-2.257 2.416c-.21.225-.326.52-.324.828v3.455a1.219 1.219 0 102.439 0V16.75l1.114-1.166 1.407 4.516a1.204 1.204 0 001.16.858c.124 0 .249-.017.368-.053a1.22 1.22 0 00.768-1.543zM8.457 17.398H6.854l2.025-1.505a.565.565 0 00.113-.753.572.572 0 00-.79-.15l-3.094 2.258a.506.506 0 00-.113.105h-.301a1.694 1.694 0 100 3.387h3.763a1.694 1.694 0 000-3.387v.045z",
      fill: "#333"
    }
  )
);
export {
  e as default
};
